import UserModel from '@/_models/UserModel'
import moment from 'moment-timezone'
import { getDatetimeFormat } from '@/_utils/datetime'
import { Constant } from '@/_services/constant'
import { localStore } from '@/_utils/localstore'
import { isEmpty } from 'lodash'

// Off button on/off
// Not received card infomation for a long time
export const isCardOff = (userData: UserModel) => {
  if (userData.measureded_at) {
    const datetimeUtc = moment(new Date(userData.measureded_at), getDatetimeFormat()).utc()
    const timeAgoInSeconds = Math.abs(moment.utc().diff(datetimeUtc, 'seconds'))

    const setting = JSON.parse(localStore.getItem('setting') as string)
    if (!setting || !setting.card_off_after_minutes) {
      // Always display cards
      return false
    }

    // True is card ON else card OFF
    return timeAgoInSeconds >= setting.card_off_after_minutes * 60
  }

  return true
}

export const isValidCoord = (latorlon: any) => {
  return typeof latorlon !== undefined && latorlon !== null && latorlon !== 0 && latorlon !== ''
}

export const isGPSMode = (userData: UserModel) => {
  return !!userData.is_outside && isValidCoord(userData.lat) && isValidCoord(userData.lon)
}

export const isIndoorMode = (userData: UserModel) => {
  if (!isEmpty(userData.nearest_beacon_id) && !isEmpty(userData.current_floor_id)) {
    return true
  }

  if (!isEmpty(userData.nearest_card_id) && !isEmpty(userData.current_floor_id)) {
    return true
  }

  return false
}

export const isBeaconNG = (user: UserModel) => {
  if (!user.beacon_alert || Object.keys(user.beacon_alert).length === 0) {
    return false
  }

  const alertCode = user.beacon_alert.message_code
  return alertCode === Constant.ALERT_CODE_BEACON_OUT || alertCode === Constant.ALERT_CODE_BEACON_FAIL
}

export const hasAlert = (user: UserModel) => {
  return !user.current_location_name
}

export const isGPSNG = (user: UserModel) => {
  if (!user.loc_alert || Object.keys(user.loc_alert).length === 0) {
    return false
  }

  const alertCode = user.loc_alert.message_code
  return alertCode === Constant.ALERT_CODE_LOC_FAIL
}

export const convertJBOXType = (jboxType: number): string => {
  if (!jboxType) {
    return ''
  }

  return ['-', Constant.CARD_TYPE_JCARD, Constant.CARD_TYPE_SMARTJCARD][jboxType] || ''
}
